/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApprenantSelectorGridDto } from './ApprenantSelectorGridDto';
import {
    ApprenantSelectorGridDtoFromJSON,
    ApprenantSelectorGridDtoFromJSONTyped,
    ApprenantSelectorGridDtoToJSON,
} from './ApprenantSelectorGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ApprenantSelectorGridDtoPaginatedResults
 */
export interface ApprenantSelectorGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ApprenantSelectorGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ApprenantSelectorGridDto>}
     * @memberof ApprenantSelectorGridDtoPaginatedResults
     */
    results?: Array<ApprenantSelectorGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ApprenantSelectorGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ApprenantSelectorGridDtoPaginatedResults interface.
 */
export function instanceOfApprenantSelectorGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantSelectorGridDtoPaginatedResultsFromJSON(json: any): ApprenantSelectorGridDtoPaginatedResults {
    return ApprenantSelectorGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ApprenantSelectorGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantSelectorGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ApprenantSelectorGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ApprenantSelectorGridDtoPaginatedResultsToJSON(value?: ApprenantSelectorGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ApprenantSelectorGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

